export const expenseValidationRules = (values) => {
  const errors = {};

  if (!values.amount) errors.amount = "Amount is required";
  else if (values.amount <= 0) errors.amount = "Amount must be greater than 0";
  else if (values.amount && !/^\d+(\.\d{1,2})?$/.test(values.amount.toString()))
    errors.amount = "At most 2 decimal places are allowed";
  if (!values.date) errors.date = "Date is required";
  if (!values.categoryId) errors.categoryId = "Please select a category";
  if (!values.fromAccountId) errors.fromAccountId = "Please select an account";

  return errors;
};
